import React, { useEffect, useState } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Alert from "../../shared/common/alert";
import { Row, Col, Button, FormGroup, Input } from "reactstrap";
import Minus from "../../../assets/images/dw20/icons/minus.png";
import Plus from "../../../assets/images/dw20/icons/plus.png";
import QuestionMark from "../../../assets/images/dw20/icons/questionMark.png";
import Play from "../../../assets/images/verboden/play.png";
import Socket from "../../../socket/socket";
import * as paramsAction from "../../../redux/gameParams/actions";
import _ from "lodash";
import sfw_switch_circle from "../../../assets/images/CHPT/sfw-switch.png";

const CpOption = (props) => {
  let sfw = props.sfw;
  let setSfw = props.setSfw;
  let round = props.round;
  let setRound = props.setRound;
  const [tooltip, set_tooltip] = useState(false);
  let roomData = props.gameReducer.roomObj;
  let scoreToWin = roomData.lobby_parameters.score_to_win;
  let game_code = roomData?.game_code;
  let users = props.gameReducer.roomObj.users;
  let gameObj = props?.paramsReducer?.gameObj?.screens?.lobby;
  let chptGameObj = props?.paramsReducer?.gameObj?.screens?.chpt;
  const status = _.get(roomData, "game_state.status");
  const gameName = props.gameReducer.gameName;
  let sfw_for_mapping =
    props.gameReducer?.roomObj?.lobby_parameters?.safe_for_work;

  // const [round, setRound] = useState(gameName && gameName !== "" && gameName === "CHPT" ? 4 : game_code && game_code !== "" && game_code === "CHPT" ? 4 : 10);

  useEffect(() => {
    if (roomData?.edition === "CHPTW") {
      setSfw(true);
    }
  }, []);

  useEffect(() => {
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      score_to_win: round
    };
    Socket.sendMessage(data);
  }, [round]);

  useEffect(() => {
    return Socket.addListener("update-status", () => {
      props.history.push("/charty-game");
    });
  }, []);

  useEffect(() => {
    console.log(status, "statusstatus");
    if (status != "Joining") {
      let gameObj = props.gameReducer;
      let dataObj = {
        gameName:
          gameObj.gameName !== "" ? gameObj.gameName : gameObj.roomObj.game_code
      };
      props.getGameData(dataObj);
      if (Object.keys(props.paramsReducer.gameObj).length > 0) {
        props.history.push("/charty-game");
      }
    }
  }, [status, props.paramsReducer.gameObj]);

  const onAddOrSubtractRound = (key) => {
    let currentRound = round;

    if (key === "add") {
      if (round >= 0) {
        if (currentRound >= 12) {
          Alert(200, "Max Score can be 12 only");
          return;
        } else {
          currentRound = parseInt(currentRound) + 1;
          setRound(currentRound);
        }
      }
    } else {
      if (round > 0) {
        currentRound = currentRound - 1;
        if (currentRound <= 1) {
          setRound(1);
        } else {
          setRound(currentRound);
        }
      }
    }
  };

  const handleChange = (e) => {
    setRound(e.target.value);

    return;
  };

  const onStartGame = () => {
    if (users && users.length < 3) {
      Alert(400, "Need at least 3 players to start the game");
      return;
    }
    if (round <= 0) {
      Alert(400, "Please enter correct no of Score to start the game");
    } else {
      let data = {};
      if (roomData.edition === "CHPTW") {
        data = {
          action: "update-status",
          roomId: roomData.id,
          scoreToWin: parseInt(round),
          tableTopName: gameName,
          rating: "sfw",
          safeForWork: sfw
        };
      } else {
        data = {
          action: "update-status",
          roomId: roomData.id,
          scoreToWin: parseInt(round),
          tableTopName: gameName,
          rating: sfw ? "sfw" : "r",
          safeForWork: sfw
        };
      }
      Socket.sendMessage(data);
    }
  };
  const sfwChange = (e) => {
    setSfw(e.target.checked);
    console.log(e.target.checked, "setSfwsetSfw");
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      safe_for_work: e.target.checked
    };
    Socket.sendMessage(data);
  };
  return (
    <>
      <div className="CHPT-game-option">
        <div className="score-to-win">
          <div className="labelWrapper">
            <p className="mr-3">
              {chptGameObj ? chptGameObj?.score_to_win_label : "Score to win"}
            </p>
            <Button
              className="lobby-footer"
              onMouseEnter={() => set_tooltip(true)}
              onMouseLeave={() => set_tooltip(false)}
            >
              <img src={QuestionMark} alt="QuestionMark" />
            </Button>
          </div>

          <div className="inpWrapper">
            <div className="round">
              <div className="counter d-flex align-items-center">
                <Button
                  className="lobby-footer"
                  onClick={() => onAddOrSubtractRound("subtract")}
                >
                  <img src={Minus} alt="minus" />
                </Button>
                <FormGroup className="mb-0">
                  <Input
                    min="1"
                    max="12"
                    type="number"
                    name="round"
                    onChange={(evt) => handleChange(evt)}
                    value={scoreToWin}
                    disabled
                  />
                </FormGroup>
                <Button
                  className="lobby-footer"
                  onClick={() => onAddOrSubtractRound("add")}
                >
                  <img src={Plus} alt="plus" />
                </Button>
              </div>
            </div>
          </div>
        </div>
        {tooltip && (
          <div className="chpt-tooltip">
            <h3>{chptGameObj?.score_to_win_tooltip_label}</h3>
            <p>{chptGameObj?.score_to_win_tooltip_text}</p>
          </div>
        )}
        {!roomData?.edition && (
          <div className="safe-to-work score-to-win">
            <div className="labelWrapper">
              <p className="mr-3">SAFE FOR WORK</p>
            </div>
            <label className="switch">
              <input
                type="checkbox"
                id="togBtn"
                checked={sfw}
                onChange={(e) => {
                  sfwChange(e);
                }}
              />
              <div className="slider round">
                {sfw_for_mapping ? (
                  <span className="on">
                    {" "}
                    <img src={sfw_switch_circle} alt="plus" />
                    ON
                  </span>
                ) : (
                  <span className="off">
                    {" "}
                    <img src={sfw_switch_circle} alt="plus" />
                    OFF
                  </span>
                )}
                {/* <span className="on">ON</span> */}
                {/* <span className="off">&nbsp;OFF</span> */}
              </div>
            </label>
          </div>
        )}
        <div className="playBtn">
          <Button className="startbtn" onClick={onStartGame}>
            {chptGameObj ? chptGameObj?.start_button : "Start"}
            <img src={Play} alt="" className="ml-4" />
          </Button>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    getGameData: (data) => dispatch(paramsAction.getGameData(data))
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(CpOption);
